import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    .editor-media-container {
        width: 100%;
    }

    ds-media {
        height: 30em;
        width: 100%;
    }

    @media only screen and (max-width: 640px) {
        .editor-media-container {
            flex-direction: column;
        }
    }
`;
